  import {
    PERITADOR_ACT_GET_REQUEST_TABS_SUCCESS,
    PERITADOR_ACT_GET_REQUEST_TABS_FAILURE,
    PERITADOR_ACT_GET_REQUEST_TABS_BEGIN,
    PERITADOR_ACT_GET_REQUEST_TABS_DISMISS_ERROR,
  } from './constants'

  import { BFFAgent } from '../../../common/BFFAgent'
  
  export function getRequestTabs(args = '') {
    return async (dispatch) => {
      dispatch({
        type: PERITADOR_ACT_GET_REQUEST_TABS_BEGIN,
      })

      try {
            const tabs = await BFFAgent.Peritador.getTabs(args)

            dispatch({
                type: PERITADOR_ACT_GET_REQUEST_TABS_SUCCESS,
                data: tabs
            })
       } catch (error) {
          dispatch({
            type: PERITADOR_ACT_GET_REQUEST_TABS_FAILURE,
            data: { error },
          })
      }
    }
  }
  
  export function dismissGetTabsRequestError() {
    return {
      type: PERITADOR_ACT_GET_REQUEST_TABS_DISMISS_ERROR,
    }
  }
  
  export function reducer(state, action) {
    switch (action.type) {
      case PERITADOR_ACT_GET_REQUEST_TABS_BEGIN:
        return {
          ...state,
          getTabsPending: true,
          getTabsError: null,
        }
  
      case PERITADOR_ACT_GET_REQUEST_TABS_SUCCESS:
        return {
          ...state,
          getTabsPending: false,
          getTabsError: null,
          requestsTabs: action.data,
        }
  
      case PERITADOR_ACT_GET_REQUEST_TABS_FAILURE:
        return {
          ...state,
          getTabsPending: false,
          getTabsError: action.data.error,
        }
  
      case PERITADOR_ACT_GET_REQUEST_TABS_DISMISS_ERROR:
        return {
          ...state,
          getTabsError: null,
        }
  
      default:
        return state
    }
  }
  